/**
 * Wraps the provided Promise into a reflector returning an object which returns the success
 * as a boolean and the result or error
 *
 * @param {Promise} promise - the promise to be wrapped
 * @returns {Promise<{isRejected: Boolean, result?: any, error?: Error}>} - reflected promise
 */
export function reflectPromise(promise) {
    return promise.then(
        result => ({ isRejected: false, result }),
        error => ({ error, isRejected: true })
    )
}
